<template>
    <div class="app" >
        <div class="bg" ></div>
        <div class="head">
            <div class="name">{{ project.projectName }}</div>
        </div>
        <div class="basicInfo">
            <div class="tem">
                <div >{{ environment.weather }}</div>
                <div>{{ environment.temperature }}<span>℃</span></div>
            </div>
            <div class="hum">
                <div>湿:</div> 
                <div>{{ environment.humidity }}<span>%</span></div>
            </div>
            <div class="exit" @click="exit">
                <div class="icon"></div>
            </div>
        </div>
        <div class="type">
            <!-- <div :class="currentPage == 4?'tabType': 'tabTypeS'" @click="pageTab(4)">
                报警
            </div> -->
            <div :class="currentPage === item.alias?'tabType': 'tabTypeS'" v-for="item in navMenu" :key="item.id" @click="pageTab(item.alias)" >
                {{item.name}} 
            </div> 
        </div>
        <div class="time">
            <p>{{ time.substr(0,11) }}</p>
            <p>{{ time.substr(11) }}</p>
        </div>
        <div class="watermark" v-show="currentPage === 'Microgrid' || currentPage === 'Distribution'">
            <img src="../assets/img/watermark.png" alt="">
        </div>
        <router-view ></router-view>
    </div>
</template>

<script>
import { getBaseInfo } from '../utils/api/index'
import {
        GetBaseInfo,
        GetAllLoopsByProjectId,
        GetTransformerNum,
        GetAllAreas,
        GetAllSecurity,
        GetLoopMaster,
        GetLoadInfo,
        getCapacity
    } from "@/components/Request";
    
    import {
        subscribebySubLoopUrl
    } from "../mqtt/index"
    export default {
        name: "App",
        data() {
            return {
                currentPage:'',
                project : {
                    projectName : '',
                    projectIcon : '',
                    projectCoordinate : ''
                },
                environment : {
                    temperature:'',
                    weather:'',
                    humidity:''
                },
                time: "",
                navMenu:[]
            };
        },
        components:{
        },
        created() {
            this.getProject();
            this.getnavMenu()
            this.getMonitor()
            this.getBuilds()
        },
        computed:{
            currentDate(){
                return this.time.substr(0,11)
            },
            currentTime(){
                return this.time.substr(11)
            }
        },
        mounted() {
            // 动态时间显示
            setInterval(() => {
                this.time = this.dateFormat("YYYY年mm月dd日 HH:MM:SS", new Date());
            }, 1000);
        },
        methods: {
            // 获取项目导航
            async getnavMenu(){
                let res = await this.$http.navMenu({projectId:this.$store.state.projectId})
                this.navMenu = res.data.data.menuTree
                this.pageTab(this.navMenu[0].alias)
            },
            // 切换导航
            pageTab(name){
                if(this.currentPage == name){
                    return 
                }else{
                    this.currentPage = name
                    this.$router.push({
                        path:`/parkoverview`,
                        query:{
                            name:name
                        },
                    })
                    this.$store.commit('set_nav',name)
                }
                
            },
            // 获取监控
            getMonitor(){
                GetAllAreas({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    let areas = data.data.areas
                    // console.log(data);
                    this.$store.commit('getAreas',areas)
                    this.$store.commit("set_val", {
                        allThreeUrl: data.data.areas
                    })
                    let surveillance = []
                    new Promise((resolve) => {
                        data.data.areas.forEach(item => {
                            GetAllSecurity({
                                areaId: item.areaId
                            }).then(({
                                data
                            }) => {
                                surveillance.push({
                                    areaId: item.areaId,
                                    rooms: {
                                        types: ["监控列表", "门禁列表"],
                                        details: [
                                            data.data.devices.filter(item =>
                                                item.device_class_name ==
                                                '监控设备'
                                            ),
                                            [],
                                        ],
                                    },
                                })
                            })
                        })
                        resolve()
                    }).then(() => {
                        this.$store.commit("set_val", {
                            surveillance: surveillance
                        })
                    })
                })
            },
            // 格式化时间
            dateFormat(fmt, date) {
                let ret;
                const opt = {
                    "Y+": date.getFullYear().toString(), // 年
                    "m+": (date.getMonth() + 1).toString(), // 月
                    "d+": date.getDate().toString(), // 日
                    "H+": date.getHours().toString(), // 时
                    "M+": date.getMinutes().toString(), // 分
                    "S+": date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
                    }
                }
                return fmt;
            },
            // 获取天气
            getWeatherInfo(location) {
                // 和风天气api 10000/天 可通过经纬度查询
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + location +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63')
                    .then(response => response.json())
                    .then(json => {
                        let environment = {
                            temperature:json.now.temp,
                            weather:json.now.text,
                            humidity:json.now.humidity
                        }
                        this.environment = environment
                    })
            },
            // 获取当前项目
            async getProject(){
                let res = await getBaseInfo(this.$store.state.projectId)
                let project = {
                    projectName : res.data.data.project.projectName,
                    // projectIcon : res.data.data.project.projectIcon,
                    projectCoordinate : res.data.data.project.projectCoordinate
                }
                this.project = project
                this.getWeatherInfo(project.projectCoordinate)
                
                this.$store.commit('Cang/getProject',res.data.data.project)
            },
            exit(){
                window.parent.postMessage({
                    cmd: 'exit',
                }, '*');
            },
            // 获取项目的楼宇
            async getBuilds(){
                let res = await this.$http.getBuildTree({projectId:this.$store.state.projectId})
                console.log(res);
                this.$store.commit('Cang/getBuildTree',res.data.data.tree[0].children)
            }
        },
    };
</script>

<style lang="less" scoped>
    .app {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        // clip-path: polygon(0 0, 100% 0, 100% 12%, 12% 12%, 12% 88%, 88% 88%, 88% 12%, 100% 12%, 100% 100%, 0 100%, 0 0);
        
    }

    .bg {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url("../assets/img/bgbgbg.png");
        background-size: 100% 100%;
        clip-path: polygon(0 0, 100% 0, 100% 12%, 12% 12%, 12% 88%, 88% 88%, 88% 12%, 100% 12%, 100% 100%, 0 100%, 0 0);
        z-index: 1;
    }
    .watermark{
        position: fixed;
        top: 20%;
        left: 20%;
        width: 240px;
        height: 164px;
        z-index: 1;
        &>img{
            width: 100%;
            height: 100%;
        }
    }
    .head {
        width: 6300/192vw;
        height: 7.8vh;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;

        .name {
            font-family: YouSheBiaoTiHei;
            color: #e6f3fd;
            font-size: 36rem;
            margin-left: 7vw;
        }
    }

    .basicInfo {
        height: 6vh;
        position: fixed;
        top: 0vh;
        right: 1vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-family: zcoolqingkehuangyouti;
        color: #e6f3fdff;
        z-index: 11;
    }

    .tem{
        width: 1000/192vw;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        
    }
    .hum {
        width: 4vw;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-right: 0.5vw;
        
    }
    .tem{
        font-size: 36rem;
        align-items: end;
        margin-right: 0.5vw;
        div:nth-child(1){
            font-family: Source Han Sans CN;
            white-space: nowrap;
        }
        div:nth-child(2){
            font-family: zcoolqingkehuangyouti;
            span{
                font-size: 18rem;
                font-family: zcoolqingkehuangyouti;
            }
        }
    }
    .hum{
        align-items: center;
        div:nth-child(1){
            font-family: Source Han Sans CN;
            font-size: 24rem;
        }
        div:nth-child(2){
            font-family: zcoolqingkehuangyouti;
            font-size: 36rem;
            span{
                font-size: 18rem;
                font-family: zcoolqingkehuangyouti;
            }
        }
    }

    .exit {
        margin-left: 1vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        position: relative;

        .icon {
            width: 24rem;
            height: 23rem;
            background: url('../assets/img/离开.png');
            background-size: 100% 100%;
            margin-right: 0rem;
        }

    }

    .time {
        width: 1830/192vw;
        height: 6vh;
        position: fixed;
        right: 11vw;
        top: 1.2vh;
        font-family: zcoolqingkehuangyouti;
        color: #e6f3fdff;
        z-index: 1;
        &>p{
            height: 2vh;
            margin: 0;
        }
        &>p:nth-child(1){
            font-size: 16rem;
            letter-spacing: 0.1vw;
font-family: zcoolqingkehuangyouti;
        }
        &>p:nth-child(2){
            font-size: 24rem;
font-family: zcoolqingkehuangyouti;
        }
    }


    .type{
        width:22vw;
        height: 4vh;
        line-height: 4vh;
        position: fixed;
        right: 24vw;
        top: 2.9vh;
        color: #fff;
        font-size: 16rem;
        display: flex;
        justify-content: space-between;
        font-family: Source Han Sans CN;
        font-weight: 400;
        z-index: 1;
        
        .tabType{
            position: relative;
            text-align: center;
            cursor: pointer;
            text-shadow: 
                0 0 1vh  rgba(13,148,255, 0.9),
                0 0 2vh  rgba(13,148,255, 0.9),
                0 0 3vh  rgba(13,148,255, 0.9);
        }
        .tabTypeS{
            position: relative;
            text-align: center;
            cursor: pointer;
            text-shadow: 
                0 0 1vh  rgba(13,148,255, 0.9),
                0 0 2vh  rgba(13,148,255, 0.9),
                0 0 3vh  rgba(13,148,255, 0.9);
        }
        .tabType::before{
            content: '';
            width:calc(100% - 3rem) ;
            height: 2rem;
            border: 1rem solid #fff;
            border-radius: 3rem;
            position: absolute;
            background-color: #fff;
            top: 0;
            left: 0;
            box-shadow: 
                0 0 1vh  rgba(13,148,255, 0.9),
                0 0 2vh  rgba(13,148,255, 0.9),
                0 0 3vh  rgba(13,148,255, 0.9);
        }

    }
    
</style>